export default Object.freeze({
  TYPE: {
    MANUAL: 'manual',
    AUTOMATIC: 'automatic',
  },
  STATE: {
    OPEN: 'open',
    ACCEPTED: 'accepted',
    FAILED: 'failed',
    CLOSED: 'closed',
    REJECTED: 'rejected',
    OLD: 'OLD',
    REQUESTED: 'blocked',
  },
});
